import React, { ReactNode, FC, useMemo } from 'react';
import { WithSpacingProps } from 'ia-react-core/~/hocs/grid/withSpacing';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import BlockGroupContext from '../_BlockGroupContext';
import { StyledBlockGroup } from './BlockGroup.styles';

export interface BlockGroupProps extends WithSpacingProps, SCP<'section'> {
  /** The block group's content */
  children: ReactNode;
}

const BlockGroupDefaultProps = {};

const BlockGroup: FC<BlockGroupProps> = (props) => {
  const blockGroupContext = useMemo(() => ({ grouped: true }), []);

  return (
    <BlockGroupContext.Provider value={blockGroupContext}>
      <StyledBlockGroup {...props} />
    </BlockGroupContext.Provider>
  );
};

BlockGroup.defaultProps = BlockGroupDefaultProps;

export default BlockGroup;
